module.exports = __webpack_public_path__ + "img/mon_rotated.7f1b5dce.png";